import { render, staticRenderFns } from "./NewsListYjj.vue?vue&type=template&id=dda70a74&scoped=true&"
import script from "./NewsListYjj.vue?vue&type=script&lang=js&"
export * from "./NewsListYjj.vue?vue&type=script&lang=js&"
import style0 from "./NewsListYjj.vue?vue&type=style&index=0&id=dda70a74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda70a74",
  null
  
)

export default component.exports